// App.jsx

import {
  BrowserRouter,
  Routes,
  Route,
  Navigate
} from "react-router-dom";

import {
  useEffect,
  useState
} from "react";

import DashboardPage from "./pages/DashboardPage";
import GeneratePage from "./pages/GeneratePage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import VerifyEmailPage from "./pages/VerifyEmailPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import HookLibraryPage from "./pages/HookLibraryPage";
import PricingPage from "./pages/PricingPage";
import PublicPricingPage from "./pages/PublicPricingPage";
import RefundPolicyPage from "./pages/RefundPolicyPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsPage from "./pages/TermsPage";
import ContactSupportPage from "./pages/ContactSupportPage";
import WaitlistAdminPage from "./pages/WaitlistAdminPage";
import MilestoneWatchPage from "./pages/MilestoneWatchPage";
import AccountSettingsPage from "./pages/AccountSettingsPage";
import StudioPage from "./pages/StudioPage";

import HomePage from "./pages/HomePage";
import FeaturesPage from "./pages/FeaturesPage";
import AboutPage from "./pages/AboutPage";

import BlogPage from "./pages/BlogPage";
import BlogCategoryPage from "./pages/BlogCategoryPage";

import WhatIsHookoraPage from "./pages/WhatIsHookoraPage";
import HookoraForNigerianCreatorsPage from "./pages/HookoraForNigerianCreatorsPage";
import HowHookoraHelpsCreatorsWriteHooksFasterPage from "./pages/HowHookoraHelpsCreatorsWriteHooksFasterPage";

import ViralHookGeneratorPage from "./pages/ViralHookGeneratorPage";
import YouTubeTitleOptimizerPage from "./pages/YouTubeTitleOptimizerPage";
import CaptionGeneratorPage from "./pages/CaptionGeneratorPage";
import HashtagGeneratorPage from "./pages/HashtagGeneratorPage";
import DescriptionRewriterPage from "./pages/DescriptionRewriterPage";
import ShortScriptGeneratorPage from "./pages/ShortScriptGeneratorPage";
import ThumbnailTextAnalyzerPage from "./pages/ThumbnailTextAnalyzerPage";

import AiToolsForNigerianCreatorsPage from "./pages/AiToolsForNigerianCreatorsPage";
import BestHookGeneratorForNigerianCreatorsPage from "./pages/BestHookGeneratorForNigerianCreatorsPage";
import ContentToolsForCreatorsInNigeriaPage from "./pages/ContentToolsForCreatorsInNigeriaPage";
import BestCaptionGeneratorForNigerianCreatorsPage from "./pages/BestCaptionGeneratorForNigerianCreatorsPage";
import HowNigerianCreatorsCanWriteBetterHooksPage from "./pages/HowNigerianCreatorsCanWriteBetterHooksPage";

import ViralHookExamplesPage from "./pages/ViralHookExamplesPage";
import HowToWriteViralHooksPage from "./pages/HowToWriteViralHooksPage";
import BestHookFormulasForTikTokPage from "./pages/BestHookFormulasForTikTokPage";
import BestRetentionStrategiesForReelsPage from "./pages/BestRetentionStrategiesForReelsPage";
import HowCreatorsIncreaseWatchTimePage from "./pages/HowCreatorsIncreaseWatchTimePage";
import BestAiToolsForContentCreatorsPage from "./pages/BestAiToolsForContentCreatorsPage";
import ScrollToTop from "./components/navigation/ScrollToTop";

function getStoredToken() {
  if (typeof window === "undefined") {
    return null;
  }

  return localStorage.getItem(
    "access_token"
  );
}

function ProtectedRoute({
  children
}) {
  const token =
    getStoredToken();

  if (!token) {
    return (
      <Navigate
        to="/login"
        replace
      />
    );
  }

  return children;
}

function PublicHomeRoute() {
  const token =
    getStoredToken();

  if (token) {
    return (
      <Navigate
        to="/dashboard"
        replace
      />
    );
  }

  return <HomePage />;
}

function ScrollToTopButton() {
  const [
    visible,
    setVisible
  ] = useState(false);

  useEffect(() => {
    const handleScroll =
      () => {
        const shouldShow =
          window.scrollY >
            500 &&
          window.innerWidth >
            1024;

        setVisible(
          shouldShow
        );
      };

    window.addEventListener(
      "scroll",
      handleScroll
    );

    window.addEventListener(
      "resize",
      handleScroll
    );

    handleScroll();

    return () => {
      window.removeEventListener(
        "scroll",
        handleScroll
      );

      window.removeEventListener(
        "resize",
        handleScroll
      );
    };
  }, []);

  const scrollToTop =
    () => {
      const start =
        window.scrollY;

      const duration =
        900;

      const startTime =
        performance.now();

      const easeInOutCubic =
        (t) =>
          t < 0.5
            ? 4 *
              t *
              t *
              t
            : 1 -
              Math.pow(
                -2 * t + 2,
                3
              ) /
                2;

      const animateScroll =
        (
          currentTime
        ) => {
          const elapsed =
            currentTime -
            startTime;

          const progress =
            Math.min(
              elapsed /
                duration,
              1
            );

          const easedProgress =
            easeInOutCubic(
              progress
            );

          window.scrollTo(
            0,
            start *
              (1 -
                easedProgress)
          );

          if (
            progress < 1
          ) {
            requestAnimationFrame(
              animateScroll
            );
          }
        };

      requestAnimationFrame(
        animateScroll
      );
    };

  return (
    <button
      onClick={
        scrollToTop
      }
      aria-label="Scroll to top"
      style={{
        position:
          "fixed",

        right: "28px",

        bottom: "28px",

        width: "54px",

        height: "54px",

        borderRadius:
          "999px",

        border:
          "1px solid rgba(148,163,184,0.2)",

        background:
          "linear-gradient(135deg, rgba(37,99,235,0.96), rgba(124,58,237,0.96))",

        color: "#ffffff",

        fontSize: "22px",

        fontWeight: 900,

        cursor: "pointer",

        zIndex: 400,

        boxShadow:
          "0 14px 34px rgba(37,99,235,0.28)",

        opacity:
          visible
            ? 1
            : 0,

        visibility:
          visible
            ? "visible"
            : "hidden",

        transform:
          visible
            ? "translateY(0px) scale(1)"
            : "translateY(18px) scale(0.92)",

        transition:
          "opacity 0.25s ease, transform 0.25s ease, visibility 0.25s ease",

        backdropFilter:
          "blur(10px)",

        WebkitBackdropFilter:
          "blur(10px)"
      }}
    >
      ↑
    </button>
  );
}

function App() {
  return (
    <BrowserRouter>
    <ScrollToTop />
      <Routes>
        {/* PUBLIC */}

        <Route
          path="/"
          element={
            <PublicHomeRoute />
          }
        />

        <Route
          path="/features"
          element={
            <FeaturesPage />
          }
        />

        <Route
          path="/pricing"
          element={
            <PublicPricingPage />
          }
        />

        <Route
          path="/about"
          element={
            <AboutPage />
          }
        />

        <Route
          path="/refund-policy"
          element={
            <RefundPolicyPage />
          }
        />

        <Route
          path="/privacy-policy"
          element={
            <PrivacyPolicyPage />
          }
        />

        <Route
          path="/terms"
          element={
            <TermsPage />
          }
        />

        <Route
          path="/contact-support"
          element={
            <ContactSupportPage />
          }
        />

        {/* AUTH */}

        <Route
          path="/login"
          element={
            <LoginPage />
          }
        />

        <Route
          path="/register"
          element={
            <RegisterPage />
          }
        />

        <Route
          path="/forgot-password"
          element={
            <ForgotPasswordPage />
          }
        />

        <Route
          path="/reset-password"
          element={
            <ResetPasswordPage />
          }
        />

        <Route
          path="/verify-email"
          element={
            <VerifyEmailPage />
          }
        />

        {/* BLOG */}

        <Route
          path="/blog"
          element={
            <BlogPage />
          }
        />

        <Route
          path="/blog/category/:slug"
          element={
            <BlogCategoryPage />
          }
        />

        {/* BLOG ARTICLES */}

        <Route
          path="/blog/what-is-hookora"
          element={
            <WhatIsHookoraPage />
          }
        />

        <Route
          path="/blog/hookora-for-nigerian-creators"
          element={
            <HookoraForNigerianCreatorsPage />
          }
        />

        <Route
          path="/blog/how-hookora-helps-creators-write-hooks-faster"
          element={
            <HowHookoraHelpsCreatorsWriteHooksFasterPage />
          }
        />

        <Route
          path="/blog/ai-tools-for-nigerian-creators"
          element={
            <AiToolsForNigerianCreatorsPage />
          }
        />

        <Route
          path="/blog/best-hook-generator-for-nigerian-creators"
          element={
            <BestHookGeneratorForNigerianCreatorsPage />
          }
        />

        <Route
          path="/blog/content-tools-for-creators-in-nigeria"
          element={
            <ContentToolsForCreatorsInNigeriaPage />
          }
        />

        <Route
          path="/blog/best-caption-generator-for-nigerian-creators"
          element={
            <BestCaptionGeneratorForNigerianCreatorsPage />
          }
        />

        <Route
          path="/blog/how-nigerian-creators-can-write-better-hooks"
          element={
            <HowNigerianCreatorsCanWriteBetterHooksPage />
          }
        />

        <Route
          path="/blog/50-viral-hook-examples"
          element={
            <ViralHookExamplesPage />
          }
        />

        <Route
          path="/blog/how-to-write-viral-hooks"
          element={
            <HowToWriteViralHooksPage />
          }
        />

        <Route
          path="/blog/best-hook-formulas-for-tiktok"
          element={
            <BestHookFormulasForTikTokPage />
          }
        />

        <Route
          path="/blog/best-retention-strategies-for-reels"
          element={
            <BestRetentionStrategiesForReelsPage />
          }
        />

        <Route
          path="/blog/how-creators-increase-watch-time"
          element={
            <HowCreatorsIncreaseWatchTimePage />
          }
        />

        <Route
          path="/blog/best-ai-tools-for-content-creators"
          element={
            <BestAiToolsForContentCreatorsPage />
          }
        />

        {/* TOOLS */}

        <Route
          path="/viral-hook-generator"
          element={
            <ViralHookGeneratorPage />
          }
        />

        <Route
          path="/youtube-title-optimizer"
          element={
            <YouTubeTitleOptimizerPage />
          }
        />

        <Route
          path="/caption-generator"
          element={
            <CaptionGeneratorPage />
          }
        />

        <Route
          path="/hashtag-generator"
          element={
            <HashtagGeneratorPage />
          }
        />

        <Route
          path="/description-rewriter"
          element={
            <DescriptionRewriterPage />
          }
        />

        <Route
          path="/short-script-generator"
          element={
            <ShortScriptGeneratorPage />
          }
        />

        <Route
          path="/thumbnail-text-analyzer"
          element={
            <ThumbnailTextAnalyzerPage />
          }
        />

        {/* PROTECTED */}

        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <DashboardPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/studio"
          element={
            <ProtectedRoute>
              <StudioPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/generate"
          element={
            <ProtectedRoute>
              <GeneratePage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/library"
          element={
            <ProtectedRoute>
              <HookLibraryPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/app/pricing"
          element={
            <ProtectedRoute>
              <PricingPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/settings"
          element={
            <ProtectedRoute>
              <AccountSettingsPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/waitlist"
          element={
            <ProtectedRoute>
              <WaitlistAdminPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/milestone-watch"
          element={
            <ProtectedRoute>
              <MilestoneWatchPage />
            </ProtectedRoute>
          }
        />

        {/* FALLBACK */}

        <Route
          path="*"
          element={
            <Navigate
              to="/"
              replace
            />
          }
        />
      </Routes>

      <ScrollToTopButton />
    </BrowserRouter>
  );
}

export default App;